// id: Unique identifier for each location (number)
// lga: Local Government Area name (string) - for display in tables
// venue: Specific venue/building name (string) - for display in tables
// address: Full physical address (string) - for display in tables/maps
// value: Form submission value (string) - what gets sent to Google Sheets when user selects this location
// formDisplayText: Text shown in registration form radio buttons (string) - user-friendly display text

export const bloodDriveLocations = [
  {
    id: 1,
    lga: "Eti Osa LGA",
    venue: "Monarch Event Centre, Oba Elegushi",
    address:
      "13, Ikate Elegushi, Lekki – Epe Express Way, Lekki Penninsula II, Lagos, Nigeria",
    value: "etiLGA",
    formDisplayText: "Eti- Osa LGA - Monarch Event Centre , Oba Elegushi",
  },
  {
    id: 2,
    lga: "Ikeja LGA",
    venue: "Jara Mall",
    address: "22 Simbiat Abiola Way, Ikeja, Lagos",
    value: "ikejaLGA",
    formDisplayText: "Ikeja LGA - Jara Mall",
  },
  {
    id: 3,
    lga: "Ikorodu LGA",
    venue: "Ikorodu General Hospital",
    address: "Oba Sekumade Road, Ikorodu, Lagos",
    value: "ikoroduLGA",
    formDisplayText: "Ikorodu LGA - Oba Sekumade Road",
  },
  {
    id: 4,
    lga: "Lagos Island",
    venue: "Tinubu Square",
    address: "Broad Street, Lagos Island, Lagos",
    value: "lagosIslandLGA",
    formDisplayText: "Lagos Island LGA - Broad Street",
  },
  {
    id: 5,
    lga: "Surulere LGA",
    venue: "Teslim Balogun Stadium",
    address: "Alh. Masha Rd, Surulere, Lagos",
    value: "surulereLGA",
    formDisplayText: "Surulere LGA - Teslim Balogun Stadium",
  },
  {
    id: 6,
    lga: "Yaba LGA",
    venue: "Indoor sports center, UNILAG",
    address: "Sports center, University of Lagos, Akoka, Yaba, Lagos",
    value: "yabaLGA",
    formDisplayText: "Yaba LGA - Indoor sports center , UNILAG",
  },
];
